export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
}

export const stringToGenderMap: Map<string | null | undefined, Gender> = new Map([
  ['FEMALE', Gender.FEMALE],
  ['MALE', Gender.MALE],
]);
